<template>
  <div class="layout flex-wrap" v-if="mode == 1">
    <div class="performance-card-item" v-for="item in items" :key="item.id">
      <div class="card-image" :style="{ backgroundImage: `url(${item.image})` }" @click="gotoView(item.id)"></div>
      <div class="card-content">
        <div class="date">{{ $moment(item.date).format("lll") }}</div>
        <h2>{{ item.title }}</h2>
        <div class="location">{{ item.location }}</div>
      </div>
    </div>
  </div>
  <div v-else-if="mode == 2">
    <div class="performance-menu-item" v-for="item in items" :key="item.id">
      <div class="menu-date">
        <div>{{ $moment(item.date).format("LL") }}</div>
        <div>{{ $moment(item.date).format("dddd LT") }}</div>
      </div>
      <div class="menu-image" :style="{ backgroundImage: `url(${item.image})` }"></div>
      <div class="menu-content">
        <div>{{ item.subTitle }}</div>
        <h2>{{ item.title }}</h2>
        <div class="location">{{ item.location }}</div>
        <div class="mt-4">
          <v-btn color="primary" depressed>{{ $t("btn.buy") }}</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    mode: {
      type: Number,
      default: 1
    }
  },
  methods: {
    gotoView(id) {
      this.$router.push({ name: "performance-view", params: { id } });
    }
  }
};
</script>

<style lang="scss">
.performance-card-item {
  flex: 1 0 100%;
  padding: 12px;
  font-size: 18px;
  .card-image {
    background-position: center;
    background-size: cover;
    padding-top: 75%;
    cursor: pointer;
  }
  .card-content {
    color: #fff;
    background: var(--background-red);
    text-align: center;
    padding: 12px;
    h2 {
      font-size: 24px;
      line-height: 2em;
      height: 6em;
      margin-bottom: 1em;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .date {
      margin-bottom: 1em;
    }
  }
}
.performance-menu-item {
  margin: 24px 0;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  background: #f0f0f0;
  .menu-date {
    color: #282828;
    padding: 16px 48px;
    width: 240px;
  }
  .menu-image {
    width: 480px;
    padding-top: 360px;
    background-position: center;
    background-size: cover;
  }
  .menu-content {
    padding: 16px 24px;
    flex: 1 0 0%;
    div {
      margin: 1em 0;
    }
    h2 {
      line-height: 1.5em;
      height: 3em;
      margin-bottom: 1em;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
@media (min-width: 960px) {
  .performance-card-item {
    flex: 1 0 25%;
    max-width: 25%;
    .card-content {
      padding: 22px;
    }
    &:nth-child(2n) {
      .card-content {
        background: var(--background-dark);
        color: #f7c9c9;
      }
    }
  }
}
</style>
